import React, { useState, useEffect } from 'react';
import logoSrc from '@assets/logo-footer-w.png';

interface LogoProps {
  className?: string;
  height?: number;
}

export function Logo({ className, height = 50 }: LogoProps) {
  const [customLogoUrl, setCustomLogoUrl] = useState<string | null>(null);

  // Load custom logo from settings
  useEffect(() => {
    fetch('/api/pdf-settings')
      .then(r => r.json())
      .then(data => {
        if (data.success && data.data?.logoFilename) {
          setCustomLogoUrl('/api/pdf-settings/logo');
        }
      })
      .catch(() => {});
  }, []);

  const logoToShow = customLogoUrl || logoSrc;

  return (
    <img
      src={logoToShow}
      alt="Firmenlogo"
      height={height}
      className={`transition-opacity ${className}`}
      style={{ maxHeight: `${height}px` }}
      onError={() => {
        if (customLogoUrl) {
          setCustomLogoUrl(null);
        }
      }}
    />
  );
}
